// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"0daecca2","240":"5fc3011b","241":"76bd5cd4","300":"2f0ddf17","395":"5edfc2ca","570":"866fa1be","617":"c66980e2","649":"44cf9e8e","754":"11662072","960":"b3347b1c"}[chunkId] + ".chunk.js";
};